import { render, staticRenderFns } from "./_ArticleNote.vue?vue&type=template&id=654cdb68&scoped=true&"
import script from "./_ArticleNote.vue?vue&type=script&lang=js&"
export * from "./_ArticleNote.vue?vue&type=script&lang=js&"
import style0 from "./_ArticleNote.vue?vue&type=style&index=0&id=654cdb68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654cdb68",
  null
  
)

export default component.exports